import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_price_book_hdr_RowClass} from '../../../dbschema/bl_fi_mst_price_book_hdr.model';

export class PriceBookHeaderContainerModel extends BaseContainerModel {
  bl_fi_mst_price_book_hdr: bl_fi_mst_price_book_hdr_RowClass = new bl_fi_mst_price_book_hdr_RowClass();
}
